<template>
    <div
    :class="['pe_hint_options', hintButtonClass]"
    >
      <div class="pe_hint_btn" @click="togglePopup">Hint</div>
      <transition name="pe_hint_reveal">
        <div :class="['pe_hint_option_buttons', hintButtonClass]" v-if="showPopup">
          
            <div :class="['pe_hint_button', hintButtonClass]" @click="hintBtn($event,'letter')">
                Letter
            </div>

            <div :class="['pe_hint_button', hintButtonClass]" @click="hintBtn($event,'word')">
                Word
            </div>
          
        </div>
      </transition>
    </div>
  </template>
  
  <script>
import { mapActions, mapState } from 'vuex'

  export default {
    data() {
      return {
        showPopup: false,
      };
    },
    methods: {
        ...mapActions({
        hint: 'game/crosswordHint',
      }),



      togglePopup() {
        this.showPopup = !this.showPopup;
      },

      hintBtn(e,hintType) {
        this.hint(hintType)
        e.target.blur()
        //this.togglePopup()
      },


    },

    computed: {
      ...mapState({
        gameType: state => state.game.type,
        game: state => state.game,
      }),

      hintButtonClass(){
        return this.game.type === 'wordsearch' ? 'wordsearch' : ''

      }
    },
  };
  </script>
  
  <style scoped lang="scss">
  .pe_hint_options {
    display: flex;
    flex-direction: row-reverse;

    background-color: var(--crossword-menu-btn-background);
    color:#fff;

    &.wordsearch{
      background-color: var(--wordsearch-menu-btn-background);
    }
    &.wordsearch:hover{
      background-color: var(--wordsearch-menu-btn-hover);
    }
  }

  .pe_hint_btn{

    padding: 0.5em;
    letter-spacing: 1px;
    border: 1px solid transparent;
    border-left: 1px solid #000;
    cursor: pointer;
    width: 70px;
    text-align: center;
    /*&:hover{
      background: var(--crossword-menu-btn-hover);
      color:#000;
    }*/
  }

  .pe_hint_option_buttons{
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    background: #fabeb9;
    color:var(--crossword-menu-btn-background);
    &.wordsearch{
      background: var(--wordsearch-menu-light);
      color:#000;
    }
  }


  .pe_hint_button{
    padding: 0.5em;
    margin: 2px;
    cursor: pointer;
    width: 70px;
    text-align: center;
   /* border: solid 1px #e72a11;
    border-radius: 5px;*/
  }
  .pe_hint_button:nth-of-type(2){
    border-right:1px solid var(--crossword-menu-btn-background);
    &.wordsearch{
      border-right:1px solid var(--wordsearch-menu-btn-background);
    }
  }


  .pe_hint_button:hover {
    opacity: 0.8;
    /*background-color:#e72a11;*/
    color: #000;
    &.wordsearch:hover{
      color:var(--wordsearch-menu-btn-hover);
    }
  }
  .pe_hint_reveal-enter-active {
    animation: pe_hint_reveal-enter 1.2s ease-out;
  }
  .pe_hint_reveal-leave-active {
    animation: pe_hint_reveal-leave 0.2s ease-out;
  }
  @keyframes pe_hint_reveal-enter {
    0%   {left: 0px; opacity: 0;}
    50% {left: -75px; opacity: 0.6;}
    100% {left: -150px; opacity: 1;}

  }
  @keyframes pe_hint_reveal-leave {
    0%   {left: -150px; opacity: 1;}
    50% {left: -75px; opacity: 0.2;}
    100% {left: 0px; opacity: 0;}

  }
  </style>
  